import { __awaiter } from "tslib";
import { useInfiniteQuery } from '@tanstack/react-query';
import { toast } from '@design-system/toast';
import { getNextCursorPageParam, getNextPageParam } from '../utils/queryUtils';
const displayErrorMessage = (error) => {
    var _a;
    if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 403) {
        toast.error(error === null || error === void 0 ? void 0 : error.data, {
            duration: 10000,
        });
    }
    throw error;
};
const hasSomeValue = (obj) => Object.values(obj).some((value) => value !== null && value !== undefined);
export const useInfiniteItems = ({ blockId, fetchFilters, fetchItems, initialPage, topicId, withCursorPagination, }) => {
    const topicQueryKey = topicId || null;
    const filtersQueryKey = hasSomeValue(fetchFilters) ? fetchFilters : null;
    const queryKey = [blockId, topicQueryKey, filtersQueryKey];
    const getUnifiedNextPageParam = (lastPage, pages) => {
        if (withCursorPagination) {
            const cursorPage = lastPage;
            return getNextCursorPageParam(cursorPage);
        }
        const classicPage = lastPage;
        const classicPages = pages;
        return getNextPageParam(classicPage, classicPages);
    };
    return useInfiniteQuery({
        queryKey,
        queryFn: (_a) => __awaiter(void 0, [_a], void 0, function* ({ pageParam, signal }) {
            try {
                if (withCursorPagination) {
                    return yield fetchItems({
                        fetchFilters,
                        afterCursor: pageParam || undefined,
                        signal,
                    });
                }
                return yield fetchItems({
                    fetchFilters,
                    page: pageParam || initialPage,
                    signal,
                });
            }
            catch (error) {
                return displayErrorMessage(error);
            }
        }),
        getNextPageParam: getUnifiedNextPageParam,
        initialPageParam: withCursorPagination ? '' : initialPage,
        staleTime: 5 * 60 * 1000,
        retry: false,
    });
};
//# sourceMappingURL=useInfiniteItems.js.map